import React from 'react';
import { PawPrintIcon } from 'lucide-react';
type PawTrailProps = {
  count?: number;
  className?: string;
  tone?: 'petrol' | 'gold' | 'cream';
};
const tones = {
  petrol: 'text-petrol/15',
  gold: 'text-gold/50',
  cream: 'text-cream/25'
};

/** Subtle decorative trail of paw prints. Purely ornamental. */
export function PawTrail({
  count = 4,
  className = '',
  tone = 'petrol'
}: PawTrailProps) {
  return <span className={`pointer-events-none flex items-center gap-3 ${tones[tone]} ${className}`} aria-hidden="true" data-id="element-81" data-mp="15e5bogtwngqx">
      {Array.from({
      length: count
    }).map((_, i) => <PawPrintIcon key={i} className="h-4 w-4 shrink-0" style={{
      transform: `rotate(${i % 2 === 0 ? -18 : 14}deg) translateY(${i % 2 === 0 ? 0 : 7}px)`
    }} data-id="element-82" data-mp="vfftso20dwao" data-mpi={i} />)}
    </span>;
}